
<div class="panel flex_column" tabindex="0" autofocus #wrapper>
	<ng-container *ngIf="notifications?.length; else noNotifications;">
		<div class="header justify_content_space_between align_items_center">
			<p class="fw500" tabindex="0">Notificaciones</p>
			<button mat-icon-button class="notifications_settings_button" matTooltip="Marcar todas como leídas" (click)="clearAllNotifications()">
				<mat-icon class="material-icons-outlined color_black_inactive">
					backspace
				</mat-icon>
			</button>
		</div>
		
		<mat-divider></mat-divider>
		<div class="flex1 notifications_container">
			<div *ngFor="let n of notifications; let i=index;" (click)="onNotificationClick(i)">
				<app-single-header-notification [notification]="n" [icon]="notificationIcons[n.type]"></app-single-header-notification>
			</div>
		</div>
	</ng-container>
	
	<ng-template #noNotifications>
		<div class="img_wrapper flex_column flex_center">
			<p class="fw500 color_black_medium_emphasis margin_bottom_medium">No tenés notificaciones nuevas</p>
			<img class="margin_bottom_medium" src="/assets/img/artwork22.svg">
		</div>
	</ng-template>
</div>

<mat-divider></mat-divider>
			
<a mat-menu-item class="load_more_notifications flex justify_content_center" [routerLink]="routerService.NOTIFICATIONS" (click)="clearAllNotifications()">
	<span class="fw500 color_accent_500">
		{{ notifications?.length ? "Ver más notificaciones" : "Ver notificaciones" }}
	</span>
</a>
